import {connect} from 'react-redux'
import {NotificationList} from "./notification-list"
import {getNotifications, selectNotification} from "./state"
import {notifications} from "./state"
import {appDictionary, listLayout} from '../../app'

const mapStateToProps = (state) => ({
  notifications: notifications(state),
  notificationView: listLayout(state),
  dictionary: appDictionary(state),
})

const mapDispatchToProps = (dispatch) => ({
  getNotifications: () => dispatch(getNotifications()),
  selectNotification: (notificationId) => dispatch(selectNotification(notificationId)),
})

export const NotificationListConnected = connect(mapStateToProps, mapDispatchToProps)(NotificationList)